export default __webpack_public_path__ + "static/media/lieferheld_m1.8e25d7fb.png";